import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getBrokeNotifications } from '../../services'
import { BrokeNotificationQueryKeys } from '@/modules/client-setting/keys'
import { GetBrokeNotificationsResponse } from '@/modules/client-setting/type'

export default function useQueryGetBrokeNotifications(
	props?: UseBaseQueryOptions<GetBrokeNotificationsResponse>,
) {
	return useQuery({
		queryKey: [BrokeNotificationQueryKeys.GetBrokeNotifications],
		queryFn: () => getBrokeNotifications(),
		...props,
	})
}
